import styled from 'styled-components';

export const PickedIconContainer = styled.div`
  display: inline-block;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  padding: 4px;
`;

export const PickedIcon = styled.button`
  display: block;
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
`;
